import GroupsColumnsLineChart from './GroupsColumnsLineChart';
import './GroupsColumnsLineChart.scss';

export default GroupsColumnsLineChart;
